import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Do I have to pay every month?',
  a: 'No. The Autonomous Child Visual System™ is a one-time payment. You own it forever. No subscriptions, no recurring charges, no surprises.'
}, {
  q: 'Can I print the system?',
  a: 'Yes. The entire 50-page eBook is formatted for A4 printing. You get fully print-ready PDFs with professional layouts, colors and designs.'
}, {
  q: 'How many kids can I use this for?',
  a: 'One purchase covers your entire household. Use it for all your children, customize routines for each of them and adapt as needed.'
}, {
  q: 'Can I customize the activities?',
  a: 'Absolutely. All templates are fully editable. Add your family’s specific activities, photos and routines. Make it 100% yours.'
}, {
  q: 'What age is this for?',
  a: 'The system works for children ages 3-12, with customizations for neurodivergent children and special needs. Visual routines are universal.'
}, {
  q: 'Do the bonuses come with it?',
  a: 'Yes. All 5 bonuses are included free with your purchase. No upsells needed — you get everything right away.'
}, {
  q: 'How long until I get access?',
  a: 'Instant. After payment you receive a download link immediately, so you can start building your system within minutes.'
}, {
  q: 'What if it doesn’t work for my family?',
  a: 'We offer a 30-day money-back guarantee, no questions asked. If you are not seeing results in the first month, we refund your purchase.'
}, {
  q: 'Does this replace professional help?',
  a: 'No. This is a parenting tool for daily routines. If your child has behavioral or developmental concerns, consult a professional.'
}, {
  q: 'Will there be updates?',
  a: 'Yes. You get lifetime access to all future updates and improvements, included at no extra cost.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-58" data-mp="2pnf0t8i31vqy">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-59" data-mp="2kvn56jk2kzty">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-60" data-mp="2fxvettz2plrv">
          ❓ Frequently Asked Questions
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-61" data-mp="2avo1azylhxnf">
          Before you buy, you might want to know...
        </p>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-62" data-mp="33mo63d4r35g5">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-63" data-mp="2ulqb1kcai89p" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-64" data-mp="2umhs7q5543gg">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-65" data-mp="3uug5fq636lky">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-blush" data-id="element-66" data-mp="2pm0rpcpd4dl" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-67" data-mp="2o1aibxf87lj" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-68" data-mp="7n42auoe4hbk">
                  <div className="overflow-hidden" data-id="element-69" data-mp="hdyt8ccl053c">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-70" data-mp="me39c19kuxt1">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}